/**
 * ヘッダー / グローバルナビゲーション
 */

// スクロールロックの解除は window.scrollTo による位置の飛びを伴うため、
// それをユーザー操作のスクロールと誤認しないよう initHeaderAutoHide 側の基準位置を再同期する
let syncHeaderScrollBaseline = () => {};

const initHeader = () => {
  const gnav = document.getElementById("js-gnav");
  const toggle = document.querySelector(".js-gnav__toggle");

  if (!gnav || !toggle) return;

  let bodyOffsetY = 0;
  let isActive = false;

  // スクロールロックは body に付与する（base/_general.scss の body.is-scrollLock）
  // モーダル (utils/modal.js) と同じ仕組みに揃えている
  const scrollDisable = () => {
    bodyOffsetY = window.scrollY;
    document.body.style.top = `${-bodyOffsetY}px`;
    document.body.classList.add("is-scrollLock");
  };

  const scrollValidity = () => {
    document.body.classList.remove("is-scrollLock");
    document.body.style.top = "";
    window.scrollTo({ top: bodyOffsetY, left: 0, behavior: "instant" });
  };

  const openGnav = () => {
    isActive = true;
    gnav.classList.add("is-active");
    gnav.removeAttribute("inert");
    gnav.setAttribute("aria-hidden", "false");
    toggle.classList.add("is-active");
    toggle.setAttribute("aria-expanded", "true");
    scrollDisable();
  };

  const closeGnav = () => {
    isActive = false;
    gnav.classList.remove("is-active");
    gnav.setAttribute("inert", "");
    gnav.setAttribute("aria-hidden", "true");
    toggle.classList.remove("is-active");
    toggle.setAttribute("aria-expanded", "false");
    scrollValidity();
    syncHeaderScrollBaseline();
  };

  toggle.addEventListener("click", () => {
    if (isActive) {
      closeGnav();
    } else {
      openGnav();
    }
  });

  gnav.querySelector(".l-gnav__backdrop")?.addEventListener("click", closeGnav);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isActive) closeGnav();
  });
};

/**
 * スクロール中はヘッダーを隠し、スクロールが止まったら再表示する
 *
 * 背景が透明な追従ヘッダーのため、ロゴ・CTAが後ろのコンテンツに重なって
 * 読みづらくなる。スクロール中だけフェードアウトさせて重なりを軽減する。
 * 実際にフェードするのは SP（768px以下）のみ。見た目の切り替えは layouts/_header.scss 側で
 * メディアクエリで絞っているため、ここではブレークポイントを持たない。
 */
const initHeaderAutoHide = () => {
  const header = document.querySelector(".l-header.p-renew-2609");

  if (!header) return;

  const HIDDEN_CLASS = "is-scrollHidden";
  const SCROLL_THRESHOLD = 8; // タッチのバウンスや微細なズレで消えないようにする最小移動量(px)
  const IDLE_DELAY = 400; // スクロール停止と判定するまでの時間(ms)。スクロールイベントは約16ms間隔で届くので約25フレーム分。スマホのフリックは指を離してから慣性で止まるまで概ね0.3〜1秒かかるため、その途中で「止まった」と誤判定しないよう長めに取る
  const TOP_OFFSET = 10; // ページ最上部では隠さない（読み込み直後のわずかなズレで消えるのを防ぐ）

  let lastScrollY = window.scrollY;
  let idleTimerId = 0;
  let isTicking = false;

  const show = () => {
    header.classList.remove(HIDDEN_CLASS);
  };

  const hide = () => {
    // メニューを開いている間はトグルボタンを隠せない
    if (document.body.classList.contains("is-scrollLock")) return;
    // キーボード操作でヘッダー内にフォーカスがある場合、消すと操作対象を見失う
    if (header.contains(document.activeElement)) return;

    header.classList.add(HIDDEN_CLASS);
  };

  const update = () => {
    isTicking = false;

    const currentScrollY = window.scrollY;
    const distance = Math.abs(currentScrollY - lastScrollY);

    if (distance < SCROLL_THRESHOLD) return;

    lastScrollY = currentScrollY;

    if (currentScrollY <= TOP_OFFSET) {
      show();
    } else {
      hide();
    }

    window.clearTimeout(idleTimerId);
    idleTimerId = window.setTimeout(show, IDLE_DELAY);
  };

  window.addEventListener(
    "scroll",
    () => {
      if (isTicking) return;
      isTicking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true },
  );

  syncHeaderScrollBaseline = () => {
    lastScrollY = window.scrollY;
    show();
  };
};

const header = () => {
  initHeader();
  initHeaderAutoHide();
};

export { header };
